<template>
    <div class="dashboard">
        <v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
            <span>{{ message }}</span>
        </v-snackbar>
        <v-progress-linear v-if="wishlistLoader" height="2" indeterminate color="primary"></v-progress-linear>
        <div class="pa-5">
            <v-layout column>
                <v-flex xs12>
                    <div class="display-1 mt-8">My Favourites</div>
                </v-flex>
                <v-flex xs12 class="mt-9">
                    <div v-if="wishlists.length == 0">
                        <v-card elevation="0">
                            <v-container fill-height fluid>
                                <v-row align="center" justify="center">
                                    <v-col class="text-center"> No Product Found </v-col>
                                </v-row>
                            </v-container>
                        </v-card>
                    </div>
                    <div v-else>
                        <v-layout row wrap>
                            <template v-for="(wishlist, index) in wishlists">
                                <v-flex xs12 md3 :key="index">
                                    <div class="mr-1 mb-1">
                                        <v-card elevation="0" style="border-radius: 25px;" outlined
                                            class="d-flex flex-column my-2" height="375">
                                            <v-img v-if="wishlist.part.image==null" class="background" contain style="border-radius: 25px;" max-height="180"
                                                src="img/book-silhouette-vector-14.png">

                                            </v-img>
                                            <v-img
                                            max-height="180"
                                            contain
                                            v-else
                                            :src="path+'/storage/part_pictures/'+wishlist.part.image"
                                            style="border-radius: 25px;"
                                            class="background"
                                            >
                                            
                                            </v-img>


                                            <div>
                                                <router-link :to="'/product/' + wishlist.part.slug"
                                                    style="text-decoration: none !important">
                                                    <div align="center" class="subtitle mt-5">
                                                        <v-clamp autoresize :max-lines="2">
                                                            {{ wishlist.part.name }}
                                                        </v-clamp>
                                                    </div>
                                                </router-link>
                                            </div>
                                            <div align="center" class="mt-5 primary--text">
                                                Kshs {{ wishlist.part.price }}
                                            </div>
                                            <v-spacer></v-spacer>
                                            <v-divider class="mx-4"></v-divider>
                                            <div class="mx-3 my-3">
                                                <v-layout row wrap>
                                                    <v-flex xs6>
                                                        <div class="my-2 mx-2">
                                                            <v-btn rounded block text class="accent--text text-none"
                                                                @click="addToCart(wishlist.part)" :loading="cartLoading &&
                                                                    wishlistIndex == wishlist.part.id">
                                                                Add to Cart
                                                                <v-icon small right>
                                                                    mdi-cart
                                                                </v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <div class="my-2 mx-2">
                                                            <v-btn rounded block text class="secondary--text text-none"
                                                                @click="removeFromWishlist(wishlist.part)" :loading="loading &&
                                                                    wishlistIndex == wishlist.part.id
                                                                    ">
                                                                Remove
                                                                <v-icon small right>
                                                                    mdi-close
                                                                </v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </div>
                                        </v-card>
                                    </div>
                                </v-flex>
                            </template>
                        </v-layout>
                    </div>
                </v-flex>
                <v-flex xs12 class="my-10">
                    <v-pagination v-if="length != 0" :length="length" total-visible="10" circle
                        v-model="wishlistPagination.current_page" @input="changePage()">
                    </v-pagination>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>
<script>
import apiCall from "@/utils/api";
import { mapGetters, mapActions } from "vuex";
export default {
    components: {},
    data() {
        return {
            path: process.env.VUE_APP_API_URL,
            loading: false,
            valid: true,
            message: "",
            color: "",
            delete: false,
            confirm: false,
            dialog: false,
            snackbar: false,
            cartLoading: false,

            searchTerm: null,
            filteredflowers: false,
            wishlistIndex: null,
        };
    },
    mounted() {
        
    },
    created() {
        this.closeNav()
        window.scrollTo(0, 0);

        this.fetchWishlists(this.wishlistPagination.current_page);
        this.startWishlistLoader();
    },
    methods: {
        ...mapActions([
            "closeNav",
            "changeLoginCardState",
            
            "startWishlistLoader",
            "stopWishlistLoader",
            "filterWishlists",
            "fetchWishlists",
            "fetchCarts"
        ]),

        changePage() {
            this.startWishlistLoader();
            if (this.filteredflowers == true) {
                this.searchButtonDisabled = false;
                apiCall({
                    url:
                        "/api/wishlist?page=" +
                        this.wishlistPagination.current_page +
                        "&type=search&search=" +
                        this.searchTerm,
                    method: "GET",
                })
                    .then((resp) => {
                        this.filterWishlists(resp);
                        this.stopWishlistLoader();
                    })
                    .catch((error) => {
                        console.log(error.response);
                        this.stopWishlistLoader();
                        this.message = "anErrorOccurredMsg";
                        this.color = "error";
                        this.snackbar = true;
                    });
            } else {
                this.fetchWishlists(this.wishlistPagination.current_page);
            }
        },
        removeFromWishlist(item) {
            this.loading = true;
            this.wishlistIndex = item.id;
            apiCall({ url: "/api/wishlist/" + item.id, method: "DELETE" })
                .then((resp) => {
                    this.message = "Item removed from wishlist successfully";
                    this.color = "success";
                    this.snackbar = true;
                    this.loading = false;
                    this.delete = false;
                    this.wishlistIndex = null;
                    this.fetchWishlists(this.wishlistPagination.current_page);
                })
                .catch((error) => {
                    this.message = "anErrorOccurredMsg";
                    this.color = "error";
                    this.snackbar = true;
                    this.loading = false;
                    this.delete = false;
                    this.wishlistIndex = null;
                    console.log(error.response);
                });
        },
        addToCart(item) {
            confirm("Are you sure you want to add item to cart?") &&
                (this.confirm = true);
            if (this.confirm) {
                this.wishlistIndex = item.id;
                this.cartLoading = true;
                apiCall({
                    url: "/api/cart",
                    data: item,
                    method: "POST",
                })
                    .then((resp) => {
                        if (resp.status == 200) {
                            this.message = resp.message;
                            this.color = "success";
                            this.cartLoading = false;
                            this.snackbar = true;

                            this.wishlistIndex = null;
                            this.confirm = false
                            this.fetchCarts(1);
                        } else if (resp.status == 409) {
                            this.message = resp.message;
                            this.color = "error";
                            this.cartLoading = false;
                            this.snackbar = true;

                            this.wishlistIndex = null;
                            this.confirm = false
                        }

                    })
                    .catch((error) => {
                        this.message = "An Error Occurred";
                        this.color = "error";
                        this.cartLoading = false;
                        this.snackbar = true;
                    });
            }
        },
    },
    computed: {
        ...mapGetters(["wishlists", "wishlistPagination", "wishlistLoader"]),
        length: function () {
            return Math.ceil(
                this.wishlistPagination.total / this.wishlistPagination.per_page
            );
        },
    },
};
</script>